import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('TechnicalStopModel')
export default class TechnicalStopModel {
  @JsonProperty('location', String, true) public location:string = undefined;
  @JsonProperty('duration', String, true) public duration:string = undefined;
}
